import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function Activities() {
  const [form, setForm] = useState({
    image: null,
  });
  const [selectedImage, setSelectedImage] = useState(null);

  const [activities, setActivities] = useState([]);

  // 🔄 Fetch Activities
  const getActivities = () => {
    fetch(`${BASE_URL}/api/getActivities.php`)
      .then((res) => res.json())
      .then((data) => setActivities(data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getActivities();
  }, []);

  // Handle File
  const handleChange = (e) => {
    setForm({ image: e.target.files[0] });
  };

  // Submit Form
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("image", form.image);

    fetch(`${BASE_URL}/api/addActivity.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then(() => {
        getActivities();
        setForm({ image: null });
        document.querySelector('input[type="file"]').value = "";
      });
  };

  // Delete Activity
  const deleteActivity = (id) => {
    if (!window.confirm("Are you sure you want to delete this activity?"))
      return;

    fetch(`${BASE_URL}/api/deleteActivities.php?id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        alert(data.message);
        getActivities();
      });
  };

  return (
    <div className="activity-page">
      {/* FORM */}
      <div className="form-container">
        <h2>➕ પ્રવૃત્તિ ઉમેરો</h2>

        <form onSubmit={handleSubmit} className="form">
          <input type="file" name="image" onChange={handleChange} required />

          <button type="submit">Submit</button>
        </form>
      </div>

      {/* TABLE */}
      <div className="table-card">
        <h2> પ્રવૃત્તિ યાદી</h2>

        <table className="activity-table">
          <thead>
            <tr>
              <th>#</th>
              <th>તારીખ</th>
              <th>ફોટો</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {activities.length > 0 ? (
              activities.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>

                  <td>{item.date}</td>

                  <td>
                    <img
                      src={`${BASE_URL}/uploads/${item.image}`}
                      width="70"
                      height="90"
                      alt=""
                      style={{
                        cursor: "pointer",
                        objectFit: "cover",
                        borderRadius: "5px",
                      }}
                      onClick={() =>
                        setSelectedImage(`${BASE_URL}/uploads/${item.image}`)
                      }
                    />
                  </td>

                  <td>
                    <button
                      style={{
                        background: "#b41212",
                        color: "#fff",
                        border: "none",
                        padding: "5px",
                        cursor: "pointer",
                        width: "100px",
                      }}
                      onClick={() => deleteActivity(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">કોઈ પ્રવૃત્તિ નથી</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {selectedImage && (
        <div className="image-modal" onClick={() => setSelectedImage(null)}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>

            <img src={selectedImage} alt="Preview" />
          </div>
        </div>
      )}
    </div>
  );
}
